import React from 'react';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { StepIconProps } from '@material-ui/core/StepIcon';
import clsx from 'clsx';
import { useStepIconStyles } from 'components/VerticalStepper/styles';
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const StepIcon = (props: StepIconProps) => {
  const classes = useStepIconStyles();
  const { active, completed } = props;

  return (
    <div
      className={clsx(classes.root, {
        [classes.active]: active,
      })}
    >
      {completed ? (
        <CheckCircleOutlineIcon className={classes.completed} />
      ) : (
        <AccessTimeIcon className={classes.active} />
      )}
    </div>
  );
};

export default StepIcon;
